import { UAParser } from "ua-parser-js";

export class UserAgentParser {
    constructor() {
        this.parser = new UAParser();
        this.result = this.parser.getResult();

        this.classes = this.buildClasses();

        this.applyClasses();
    }

    /**
     * Build all classes from the data model only
     */
    buildClasses() {
        const classes = [];

        // OS
        if (this.isAndroid()) classes.push("is-android");
        if (this.isIOS()) classes.push("is-ios");
        if (this.isMacOS()) classes.push("is-macos");
        if (this.isWindows()) classes.push("is-windows");
        if (this.isLinux()) classes.push("is-linux");

        // Browser
        if (this.isChrome()) classes.push("is-chrome");
        if (this.isSafari()) classes.push("is-safari");
        if (this.isFirefox()) classes.push("is-firefox");
        if (this.isEdge()) classes.push("is-edge");

        // Device
        if (this.isMobile()) classes.push("is-mobile");
        if (this.isTablet()) classes.push("is-tablet");
        if (this.isDesktop()) classes.push("is-desktop");

        // CPU
        if (this.isARM()) classes.push("is-arm");
        if (this.isX86()) classes.push("is-x86");

        // Touch
        if (this.hasTouch()) {
            classes.push("has-touch");
        } else {
            classes.push("no-touch");
        }

        return [...new Set(classes)];
    }

    /**
     * Apply to <html>
     */
    applyClasses(element = document.documentElement) {
        element.classList.add(...this.classes);
    }

    /**
     * =========================
     * OS detection (data model)
     * =========================
     */

    isAndroid() {
        return (this.result.os.name || "").toLowerCase().includes("android");
    }

    isIOS() {
        return (this.result.os.name || "").toLowerCase().includes("ios");
    }

    isMacOS() {
        return (this.result.os.name || "").toLowerCase().includes("mac");
    }

    isWindows() {
        return (this.result.os.name || "").toLowerCase().includes("windows");
    }

    isLinux() {
        return (this.result.os.name || "").toLowerCase().includes("linux");
    }

    /**
     * =========================
     * Browser
     * =========================
     */

    isChrome() {
        return (this.result.browser.name || "").toLowerCase().includes("chrome");
    }

    isSafari() {
        const name = (this.result.browser.name || "").toLowerCase();
        return name.includes("safari") && !name.includes("chrome");
    }

    isFirefox() {
        return (this.result.browser.name || "").toLowerCase().includes("firefox");
    }

    isEdge() {
        return (this.result.browser.name || "").toLowerCase().includes("edge");
    }

    /**
     * =========================
     * Device
     * =========================
     */

    isMobile() {
        return this.result.device.type === "mobile";
    }

    isTablet() {
        return this.result.device.type === "tablet";
    }

    isDesktop() {
        return !this.result.device.type;
    }

    /**
     * =========================
     * CPU
     * =========================
     */

    isARM() {
        return (this.result.cpu.architecture || "")
            .toLowerCase()
            .includes("arm");
    }

    isX86() {
        const arch = (this.result.cpu.architecture || "").toLowerCase();
        return arch.includes("x86") || arch.includes("amd64");
    }

    /**
     * =========================
     * Touch
     * =========================
     */

    hasTouch() {
        return (
            "ontouchstart" in window ||
            navigator.maxTouchPoints > 0
        );
    }

    /**
     * =========================
     * Utilities
     * =========================
     */

    getClasses() {
        return this.classes;
    }

    getResult() {
        return this.result;
    }
}